import React from "react";
import { Box, Stack, CardMedia } from "@mui/material";

const MediaGallery = ({ mediaItems, activeMedia, setActiveMedia }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: { xs: "flex-start", md: "stretch" },
        flexWrap: "nowrap",
        gap: 2,
      }}
    >
      {/* THUMBNAILS */}
      <Stack
        spacing={1}
        sx={{
          width: { xs: 52, sm: 72 },
          flexShrink: 0,
          alignItems: "center",
        }}
      >
        {mediaItems.map((item, i) => (
          <Box
            key={i}
            onClick={() => setActiveMedia(item)}
            sx={{
              width: { xs: 44, sm: 60 },
              height: { xs: 44, sm: 60 },
              border:
                activeMedia?.src === item.src
                  ? "2px solid #ffa41c"
                  : "1px solid #ddd",
              borderRadius: 1,
              cursor: "pointer",
              bgcolor: "#fff",
            }}
          >
            {item.type === "image" ? (
              <img
                src={item.src}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            ) : (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  bgcolor: "#000",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                }}
              >
                ▶ Video
              </Box>
            )}
          </Box>
        ))}
      </Stack>

      {/* MAIN MEDIA */}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          alignSelf: "flex-start",
        }}
      >
        {activeMedia?.type === "video" ? (
          <video controls style={{ width: "100%", height: "100%", maxHeight: 420 }}>
            <source src={activeMedia.src} />
          </video>
        ) : (
          <CardMedia
            component="img"
            image={activeMedia?.src}
            sx={{
              width: "100%",
              height: { xs: 300, sm: 360, md: 420 },
              objectFit: "contain",
              bgcolor: "#fff",
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default MediaGallery;